"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencies = void 0;
exports.currencies = {
    treatmetravel: {
        NZD: {
            paymentMethods: [
                "stripe",
                "giftcard",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
    },
    dealstravel: {
        AUD: {
            paymentMethods: [
                "stripe",
                "paypal",
                "giftcard",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
    },
    cudotravel: {
        AUD: {
            paymentMethods: [
                "stripe",
                "paypal",
                "giftcard",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
    },
    cudo: {
        AUD: {
            paymentMethods: [
                "stripe",
                "braintree",
                "stripe_payment_element_card",
            ],
        },
    },
    deals: {
        AUD: {
            paymentMethods: [
                "stripe",
                "braintree",
                "stripe_payment_element_card",
            ],
        },
    },
    treatme: {
        NZD: {
            paymentMethods: [
                "stripe",
                "braintree",
                "stripe_payment_element_card",
            ],
        },
    },
    scooponexperience: {
        AUD: {
            paymentMethods: [
                "stripe",
                "applepay",
                "braintree",
                "stripe_custom_payto",
                "stripe_payment_element_card",
            ],
        },
    },
    scoopontravel: {
        AUD: {
            paymentMethods: [
                "stripe",
                "applepay",
                "paypal",
                "giftcard",
                "stripe_custom_payto",
                "stripe_payment_element_card",
                "googlepay",
            ],
        },
    },
    kogantravel: {
        AUD: {
            paymentMethods: [
                "stripe",
                "braintree",
                "giftcard",
                "stripe_payment_element_card",
            ],
        },
    },
    lebusinesstraveller: {
        AUD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_business_card",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
    },
    leagenthub: {
        AUD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
        NZD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
        GBP: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
            ],
        },
        USD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
            ],
        },
    },
    leagenthub_cvfr: {
        AUD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
        NZD: {
            paymentMethods: [
                "stripe",
                "stripe_payment_element_card",
                "applepay",
                "googlepay",
            ],
        },
    },
    led_admin: {
        AUD: {
            paymentMethods: [
                "stripe",
                "braintree",
            ],
        },
        NZD: {
            paymentMethods: [
                "stripe",
                "braintree",
            ],
        },
    },
    luxuryescapes: {
        AUD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "qantas",
                "giftcard",
                "bridgerpay",
                "applepay",
                "googlepay",
                "waave_bp",
                "velocity",
                "gocardless",
                "stripe_custom_payto",
                "stripe_payment_element_card",
                "stripe_payment_element_klarna",
                "secure_payment",
                "azupay_pay_id",
                "le_points",
                "paypal",
            ],
        },
        CAD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        CNY: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "stripe_payment_element_card",
                "stripe_payment_element_wechatpay",
            ],
        },
        EUR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
                "stripe_payment_element_klarna",
                "paypal",
            ],
        },
        HKD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
                "paypal",
            ],
        },
        // Please make sure you don't allow new payment methods to be displayed in spoof for INR (except secure_payment)
        INR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "stripe_payment_element_card",
                "secure_payment",
            ],
        },
        IDR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        ILS: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                // "applepay",  // Apple Pay is not supported in IL
                // "googlepay", // Google Pay is not supported in IL
                "stripe_payment_element_card",
            ],
        },
        JPY: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        KRW: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "stripe_payment_element_card",
            ],
        },
        MOP: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "applepay",
                "stripe_payment_element_card",
            ],
        },
        MYR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "googlepay",
                "hoolah_bp",
                "atome_bp",
                "stripe_payment_element_card",
                "stripe_payment_element_grabpay",
            ],
        },
        NZD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "afterpay_bp",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
                "stripe_payment_element_klarna",
                "paypal",
            ],
        },
        PHP: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        QAR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                // "applepay",  // Apple Pay is not supported in QA
                // "googlepay", // Google Pay is not supported in QA
                "stripe_payment_element_card",
            ],
        },
        RUB: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                // "applepay", // Apple Pay is not supported in RU
                // "googlepay", // Google Pay is not supported in RU
                "stripe_payment_element_card",
            ],
        },
        SAR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                // "applepay", // Apple Pay is not supported in SA
                // "googlepay", // Google Pay is not supported in SA
                "stripe_payment_element_card",
            ],
        },
        SGD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "hoolah_bp",
                "atome_bp",
                "stripe_payment_element_card",
                "stripe_payment_element_paynow",
                "stripe_payment_element_grabpay",
                "paypal",
            ],
        },
        TWD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        THB: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        ZAR: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                // "applepay", Apple Pay is not supported in South Africa
                // "googlepay", Google Pay is not supported in South Africa
                "stripe_payment_element_card",
            ],
        },
        AED: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
            ],
        },
        GBP: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "stripe_payment_element_card",
                "stripe_payment_element_klarna",
                "paypal",
            ],
        },
        USD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                "applepay",
                "googlepay",
                "afterpay_bp",
                "stripe_payment_element_card",
                "stripe_payment_element_klarna",
                "paypal",
            ],
        },
        VND: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "giftcard",
                "krisFlyer",
                // "googlepay", // Google Pay is not supported in South Africa
                "stripe_payment_element_card",
            ],
        },
    },
    yidu: {
        CNY: {
            paymentMethods: [
                "partner",
            ],
        },
    },
    zoomzoom: {
        AUD: {
            paymentMethods: [
                "partner",
            ],
        },
    },
    newwhitelabel: {
        AUD: {
            paymentMethods: [
                "stripe",
                "le_credit",
                "paypal",
                "qantas",
                "giftcard",
                "bridgerpay",
                "applepay",
                "googlepay",
                "afterpay_bp",
                "stripe_payment_element_card",
            ],
        },
    },
};
